<template>
  <div class="chapters"  >
    <div v-for="(chapter, index) in chapters" :class="( chapter.class )" :id="( chapter.class )">
      <div class="outer">
        <div class="inner">
          <span v-if="chapter.subtitle">{{ chapter.subtitle }}</span>
          <h2>{{ chapter.title }}</h2>
          <div v-if="chapter.body" v-html="chapter.body"></div>
          <div v-if="chapter.images" class="gallery">
            <img v-for="image in chapter.images" v-bind:src="image.url"/>
          </div>

          <employabilities v-if="chapter.class == 'chapter_employability'"></employabilities>
          <jobtitles limit="3" v-if="chapter.class == 'chapter_functions'"></jobtitles>
          <experiences v-if="chapter.class == 'chapter_experience_two_worlds'"></experiences>
        </div>
      </div>
    </div>
    <contactformblock pagename="retailmade"></contactformblock>

  </div>
</template>

<script>
  import { deliveryClient } from '@/kontent.js'
  import employabilities from '@/components/employabilities.vue'
  import jobtitles from '@/components/jobtitles.vue'
  import experiences from '@/components/experiences.vue'
  import contactformblock from '@/components/contactformblock.vue'


  export default {
    name: 'chapters',
    components: {
      employabilities,
      jobtitles,
      experiences,
      contactformblock

    },
    props: {
      pagename: String
    },
    data: function() {
      return {
        chapters: []
      }
    },
    created: function(){
      var query = deliveryClient
      .items()
      .type('hoofdstuk')
      .orderParameter('elements.hoofdstuknummer', deliveryClient.SortOrder)
      .containsFilter('elements.sitemap', [this.pagename])
      .toPromise()
      .then(response => {
        this.$data.chapters = response.items.filter(function(item){
          if(item.inhoud.value == "<p><br></p>"){
            delete item.inhoud.value;
          }
          return item;
        }).map(item => ({
          title: item.titel.value,
          subtitle: item.ondertitel.value,
          body: item.inhoud.value,
          images: item.afbeeldingen.value,
          class: item.system.codename
        }))
      })
    },
    mounted(){
    }
  }
</script>
